



                                                                                  


import { getLink } from '../../../utils/utils';


const content = {
  esp: (
    `
      <div style="text-align:justify;">
        <p class="mb-3">
          Foje, kaj ne simple foje, sed en printempa monato nisano, decidis du odesaj esperantistinoj Esperantan kongreson viziti. 
          Kaj ne simplan kongreson, sed Azian, kiu okazos en la urbo Jerusalemo, sankta loko sur la Sankta Tero.
        </p>
        
        <p class="mb-3">
          Skribis ili al la Organiza Komitato kaj demandis: “Kiuj estos kondiĉoj, se ni prelegon preparos, ĝuste laŭ la temo de la Kongreso estimata; 
          kaj kelkajn filmojn, de ni kreitajn en nia kara lingvo, prezentos; kaj eĉ seminarion gvidi povos?” 
          Kaj respondis la estroj de la estimata Kongreso: “Eĉ cent prelegojn vi faru, eĉ ducentfoje kontribuu - ne ricevos vi rabaton, nek rekompencon, nek premion. 
          Volas – kontribuu, ne volas – ne kontribuu; sed pagi vi devas plene!” 
        </p>
        
        <p class="mb-3">
          Ekploris tiam odesaj esperantistinoj, kaj foriris plorante, kaj sidis ili sur la bordo de Nigra maro plorante kaj veante. 
          Kaj venis tiam al ili la ideo bona: “Venu ni al la Sankta Tero, ekkonu ni belecon ĝian, plenigu ni animojn niajn per frateco kaj amikeco, 
          kiel postulis la Majstro nia – kaj malfermiĝos por ni la pordego de la Kongreso, - almenaŭ por unu tago!”
        </p>
        
        <p class="mb-3">
          Streĉis ili mensojn siajn – kaj ekmemoris, ke loĝas en tiu lando malproksima multaj amikoj sinceraj, per Esperanto ligitaj. 
          Kaj unu el tiuj amikoj invitis ilin al hejmo sia, por ke ekvidu iliaj okuloj tiun belecon kaj sanktecon de Esperanta Kongreso. 
          Kaj venis ili, kaj renkontis ilin Paŭlo brava. 
        </p>
        
        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. 
          La tago unua.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Ekde mateno, ĉar ne malfermiĝis ankoraŭ la Sanktaĵo de la Kongreso, venis ili al aliuj sanktaĵoj. 
          La lago Galilea, Nazareto, la valo Armagedona, la monto Tabor, la rivero Jordano kun la loko de Sankta Bapto; ruinoj de urboj Tiberiada, Magdala, Kana, 
          Kapernaum...
        </p>

        <p class="mb-3">
          En Nazareto, en la Templo de Anunciacio, multajn bildojn de Madono vidis ili, kaj inter donacoj, de diversaj landoj senditaj, 
          trovis ili “La Madonon de Esperantistoj”. 
          Sube, anstataŭ la nomo de la lando, “Esperantos” estis skribita, kaj la Madono sur la fono de verda stelo videblis, kaj la surskribo anoncis: 
          “Nia Sinjorino de la Espero, Patronino de la esperantistoj”. 
          Kaj tuj esperantistoj aperis. Antaŭkongreson ili ĝuis. 
          Tiel sukcesis ankaŭ niaj esperantistinoj kun amikoj kuniĝi. 
          Ne trafis ili al la Kongreso – do la Kongreso mem al ili venis! 
        </p>

        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. 
          La tago dua.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Logas esperantistinojn nekonata tero, kaj jen elektis ili por la tago tria la temon mirindan: “Jerusalemo, la ĉefurbo de tri religioj”. 
          Vidis ili kvartalojn armenan, judan, mosleman kaj kristanan. 
          Vidis ili la monton Cionon kaj la tombon de la caro Davido; vidis la Krucan Vojon, la monton Golgota kaj la Templon de la Sankta Tombo. 
          Vidis la urbon Lod, kie Sankta Georgo naskiĝis; vidis malnovan urbon Ramla, kiu antaŭ 1400 jaroj fondita estis. 
          Vidis monaĥejon Latrun kaj ruinon de Emaus, vidis la monton de Samuelo... multon vidis ili en tiu tago. 
          En la ĉambro de la Sankta Manĝo estis ni, kaj ĉe la Muro de Lamentoj... 
          Vidis Gehenan valon... 
          Jes, multon vidis ni en tiu tago, kaj multo restis en ni poreterne...
        </p>

        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. 
          La tago tria.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Kaj vokas denove niajn esperantistinojn la tero fremda, la tero antikva. 
          Kaj venis ili al al valo, kie floras lilio de Ŝarono neĝe blanka, kun kiu komparis la reĝo Salomono amatinon sian. 
          Kaj trairis riveron Aleksandr, kie haltis iam Aleksandro la Granda. 
          Kaj venis ni al ŝtona Akreo (Akko), kie Kruckavaliroj regis, sed antaŭe – kaj fenicoj, kaj egiptanoj, kaj araboj. 
          Estis ni en kavalira kastelo, kaj tremis niaj koroj pro la tuŝo al la Historio kvarmiljara...
        </p>

        <p class="mb-3">
          Kaj estis ni en la 8a Monda Miraklo – la Ĝardenoj de Bahaoj. 
          Kiel solena ŝtuparego etendĝas ili sur la monto Karmel; per profunda harmonio impresas ilia simetrio; kvazaŭ paradiza muziko lirlas la akvo, 
          fluanta apud la ŝtuparo, akomponanta niajn paŝojn. 
          La simbolo de eterna vivo, senĉese sonas la kanto de la akvo, ĉar la akvo signifas vivon... 
        </p>
        
        <p class="mb-3">
          Kaj ne forgesos ni, ke bahaanoj predikas unu komunan lingvon por la homaro, kaj tiu lingvo estas Esperanto. 
          Ĉie en tiu mirakla lando ĉeestas Esperanto; kaj ĉiam kun bonaj kaj sanktaj aferoj ĝi estas kunligita. 
        </p>

        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. La tago kvara.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Sabato, sabato, la Sankta Ŝabato! 
          Sed jam ĝi estas ne por, sed kontraŭ Esperanto! 
          Hodiaŭ intencis ni veni al la Kongreso – sed Ŝabato malpermesas! 
          Ne povos ni reveni hejmen, ja la busoj ĉesos veturi je la kvara tage! 
          Ho, adiaŭ la belaj revoj pri amikaj renkontiĝoj, interesaj prelegoj kaj ravaj koncertoj! 
          Ni devos resti hejme kaj... ho, kiel strange! – nenien kuri, strebi, nenion ensorbi... 
          Kaj nur nun percepti plenforte kaj plenamplekse ĉion, kion ni vidis, aŭdis, tuŝis, flaris dum tiuj tagoj, kiuj egalas al multaj monatoj. 
        </p>

        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. 
          La tago kvina.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Tel-Avivo – novega urbo kun ĉielskrapuloj, modernaj domoj kun ĝardenoj surtegmentaj, kun la Placo de la Lando, kie videblas, 
          ke 2/3 de la lando okupas dezerto. 
          Sed kia bela kaj verda estas la cetera areo!
        </p>

        <p class="mb-3">
          Jaffa. 
          Safari-parko kun zebroj, antilopoj kaj strutoj. 
          17 behemotoj en unu lageto. 
          Freneza elefanto, kiu mortigis sian kunulinon, kaj nun loĝas en ekzilo, aparte de la familio. 
          Simioj grandaj kaj malgrandaj, kaj multaj aliaj simpatiaj estaĵoj. 
        </p>

        <p class="mb-3">
          Jaffa. 
          La loko, kie estis konstruita la arkeo de Nia. 
          La Roko de Andromeda, kie savis ŝin Perseo, revenanta sur Pegazo post la venko super terura Meduzo. 
          Artista kvartalo... sed ne, la Artistan kvartalon ni ne atingu! 
          Furioza pluvo forlavis nin de ĝiaj deklivaj stratetoj, pavimitaj de tiel glitaj flavaj ŝtonplatoj!
        </p>

        <p class="mb-3">
          Kaj estis mateno, kaj estis vespero. 
          La tago sesa.
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-3">
          Kaj la Tago Sepa estis, kompreneble, la Tago de ripozo. 
          For – seriozajn temojn! 
          For – fortajn impresojn kaj doktajn tezojn! 
          Dum tri tagoj ni nur sunbaniĝas, naĝas kaj promenas vespere laŭ viglaj stratoj de urbo Eilat, la plej suda punkto de la lando. 
          La Ruĝa maro de la Hinda oceano etendiĝas apude; la fama Ruĝa maro kun ĝiaj koraloj, la plej pitoreskaj en la mondo!
        </p>

        <p class="mb-3">
          Certe, ni nepre vizitis la Akvarion de Eilat, kun ĝia Observatorio, kie sur la profundeco de 6 metroj ni povas observi la veran, 
          vivantan koralan rifon kaj ĝiajn enloĝantojn, la plej ekzotikajn fiŝojn! 
          Testudoj, ŝarkoj, rajoj; diversaj akvarioj, ŝipeto kun vitra fundo... 
          Malfermado de perlaj konkoj kun nepra trovo de belaj perloj ene... 
          Grandega juvelvendejo kun perloj, briliantoj, safiroj, smeraldoj...
        </p>

        <p class="mb-5">
          Luksaj hoteloj, kien ĉiu povas enveni kaj vagadi tie; jen ekkuŝi en ĝardeno apud baseno, 
          jen leviĝi en lifto al 12a etaĝo por vidi sube gaje brilantan per lumoj, senzorgan Eilat...
        </p>

        <p class="mb-3">
          Kaj ĉie – “Krokodiloj, palmoj, baobaboj” 😀. 
          Orienta fabelo. 
          Ne strange, ke nia Sepa tago daŭris iom pli longe...
        </p>

        <p class="mb-3">
          Sed tamen - estis mateno, kaj estis vespero. 
          Kaj poste venis...
        </p>


        <p class="text-center bold mb-3 mt-3">* * *</p>


        <p class="mb-5">
          La tago lasta...
        </p>


        <p class="mb-3">
          Laŭidee, ĝi devas esti la lundo. 
          Kaj lundo, kiel ĉiuj scias, estas la tago malfacila. 
          Ho, ni konfirmas tion. 
          Por tiu tago ni elektis la plej malfacilan taskon: ripozon ĉe la Morta maro. 
        </p>

        <p class="mb-3">
          Vere, estas peza laboro. 
          Eniri en la lagon preskaŭ ne eblis, ĉar la fundo el la sala krusto estas ege akra kaj, malgraŭ piedvesto, dolorigas piedojn. 
          Krome, grandaj ondoj renkontis nin kaj plaŭde kriis: “Iru for! Ĉi tie ne estas la loko por homoj! Tio estas la Morta maro!”. 
          Jes, severas naturo. 
          Nevane apude troviĝis iam Sodomo kaj Gomoro. 
        </p>

        <p class="mb-5">
          Sed homoj aliigis la naturon – kaj langvore kaj lante oni poste ĝuas en radonaj, sulfuraj kaj ceteraj banejoj, kun vaaarma malstreĉiga aakvoo...
        </p>

        <p class="mb-5">
          Reen – la vojo tra dezerto. 
          Denove oni rememoras orientajn fabelojn, “1001 noktojn”, rakontojn de Tibor Sekelj pri diversaj dezertoj.
        </p>

        
        <p class="mb-3">
          Tamen, ni trovis Esperanton sur la Sankta Tero!
        </p>

        <p class="mb-3">
          Dankon al la organizantoj de la Kongreso, kiuj donis al ni tiun unikan eblecon! 😉
        </p>
      </div>
    `
  )
}

const itemName = {
  esp: 'Kiel du odesaninoj azian kongreson partopreni decidis, kaj kio el tio rezultiĝis'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: 'Odesaninoj'
  }
}

export default item;